import React, {createRef, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import LandMarkReward from '../../../assets/images/landmark reward.svg';
import infoIcon from '../../../assets/images/infoIcon.svg';
import cogoToast from 'cogo-toast';
import SuccessToast from '../../../components/notifications/SuccessToast';
import Stepper from '../../../components/stepper/Stepper';
import {promoResponse} from '../../../redux/checkoutSlice';
import logo from '../../../assets/images/max logo.svg';

import {
  generateInvoice,
  invoiceGeneratedResponse,
  invoiceGeneratedError,
  transactionStatusResponse,
  transactionStatusError,
  invoiceGeneratedLoading,
  resetTransactionResponse,
  lmrCheckedData,
  requestTxnToken,
  resetInvoiceResponse,
  resetPaymentStatus,
  setTxnToken,
  txnToken,
  mmrpError,
  resetMMRPState,
  lmrRedeemData,
  lmrRedeemDataResp,
  lmrRedeemDataError,
  lmrRedeemDataLoading,
  resetLmrRedeemDataResponse,
  resetOrderState,
} from '../../../redux/orderSlice';
import CartInfo from '../CartInfo';
import ProductCard from '../shoppingbag/ProductCard';
import {useLocation} from 'react-router-dom';
import ScanQrModel from '../../../components/modal/MidScreenModal';
import QRCode from 'react-qr-code';
import {
  getTransactionStatus,
  transactionStatus,
} from '../../../redux/paymentSlice';
import {BackButtonAction} from '../../../core/utils/string.util';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
  setLoaderRunning,
  setPaymentMode,
  setPaymentEnableButton,
} from '../../../redux/globalSlice';
import ErrorToast from '../../../components/notifications/ErrorToast';
import {
  getLmrChecked,
  getOrderID,
  getStoreInformation,
  getUserType,
  setCheckSum,
  setLmrCheck,
  setOrderResp,
} from '../../../core/localstorage-data';
import {logout} from '../../../core/utils/routing.util';
import LMRrewards from '../../lmrrewards';
import ReactTooltip from 'react-tooltip';
import {
  getAccessToken,
  getUser,
  getStoreCode,
  getMetadata,
  // setPaymentEnableButton,
} from '../../../core/localstorage-data';
import {
  orderResponse,
  verifyPaymentStatus,
  paymentStatus,
  fetchOrder,
  checkTransactionStatus,
  transactionStatusResponseLoading,
  resetTxnToken,
  setLmrChecked,
  paymentStatusError,
  paymentStatusLoading,
} from '../../../redux/orderSlice';
import {
  beginPayment,
  checkoutGtmData,
  purchaseEventGA,
  finalOrderPayment,
  setPageName,
} from '../../../lib/tagmanager';
import {
  eventNames,
  orderCompleteEvent,
  pageName,
  PAYTM_MID_META_KEY,
  qrPaymentMode,
  linkPaymentMode,
} from '../../../lib/constants';
import {OrderResponse} from '../../../lib/order-types';
import {orderDetailInfo} from '../../../lib/types';

import {setActivityRunning} from '../../../redux/globalSlice';
import {
  qrCodePayment,
  qrCodeResponse,
  errorInqrpayment,
  qrPaymentLoading,
  resetQrPaymentState,
} from '../../../redux/qrPaymentSlice';
import {
  requestLinkPayment,
  requestLinkResponse,
  errorInrequestLink,
  requestLinkPaymentLoading,
  resetLinkPaymentState,
} from '../../../redux/requestLinkPaymentSlice';
import {
  paymenrVerification,
  paymentVerifyResponse,
  errorInVerifypayment,
  verifyPaymentLoading,
  resetVerifyPaymentState,
} from '../../../redux/paymentVerificationSlice';
import {
  onPayNowMoengageEvent,
  paymentRecieveMoengageCall,
} from '../../../lib/moengageCall';
import InformationToast from '../../../components/notifications/InformationToast';
declare global {
  interface Window {
    Paytm: any;
  }
}
type PriceDetails = {
  totalMRP: number;
  promoDiscountAmount: number;
  totalAmount: number;
  lmrRewardsPrice?: number;
};

let genertedLinkId = '';
let generatedOrderId = '';
let showPaymentStatus = 0;
let timer2 = 0;
let settimer1 = 0;
let settimer2 = 0;
let BAG_PRICE = 0;
//let paymentAttemptTimer = 0;
let checksum: string | null;
let orderId: string | null;
//let paymentAttempCounter = 0;
let employeePaymentCheckCounter = 0;
//let paymentAttemptStatus = true;
let paymentEmpCount = 0;
function loadCheckoutScript(
  paytmURL: string,
  callback?: (success: boolean) => void,
) {
  if (window && window.Paytm && window.Paytm.CheckoutJS) {
    console.log('paytm already exists. skipping the scirpt load.');
    return;
  }

  if (!paytmURL) {
    console.log('did not load paytm preload script... payment is failing..');
    return;
  }

  const scriptElement = document.createElement('script');
  scriptElement.async = true;
  scriptElement.src = (paytmURL as any).value;
  scriptElement.type = 'application/javascript';
  scriptElement.onload = () => {
    console.log('paytm script loaded...');
    if (callback) callback(true);
  };

  scriptElement.onerror = error => {
    console.error('paytm script load failed...', error);
    if (callback) callback(false);
  };

  document.body.appendChild(scriptElement);
}

const Payment = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const storeCode = `0${getStoreInformation().store_code}`;
  const orderResp = useAppSelector(orderResponse);
  const [showLmrPoint, setShowLmrpoint] = useState(false);
  const requestLinkResp = useAppSelector(requestLinkResponse);
  const requestLinkError = useAppSelector(errorInrequestLink);
  const requestLinkPaymenthasLoaded = useAppSelector(requestLinkPaymentLoading);
  const [payNowButton, setPayNowButtonEnable] = useState(false);
  const errorInPaymentStatus = useAppSelector(paymentStatusError);
  const paymentStatusLoaded = useAppSelector(paymentStatusLoading);
  const paymentVerifyResp = useAppSelector(paymentVerifyResponse);
  const verifyPaymentError = useAppSelector(errorInVerifypayment);
  const verifyPaymentHasLoaded = useAppSelector(verifyPaymentLoading);
  const qrCodeResp = useAppSelector(qrCodeResponse);
  const qrPayementError = useAppSelector(errorInqrpayment);
  const qrPaymentHasLLoaded = useAppSelector(qrPaymentLoading);
  const txn_Token = useAppSelector(txnToken);
  const verifyPaymentResp = useAppSelector(paymentStatus);
  const invoiceResponse = useAppSelector(invoiceGeneratedResponse);
  const transactionStatusResp = useAppSelector(transactionStatusResponse);

  const lmrRedeemResponse = useAppSelector(lmrRedeemDataResp);
  const lmrRedeemError = useAppSelector(lmrRedeemDataError);
  const lmrRedeemLoading = useAppSelector(lmrRedeemDataLoading);

  const transactionStatusRespError = useAppSelector(transactionStatusError);
  const invoiGenerationError = useAppSelector(invoiceGeneratedError);
  const transactionStatusLoading = useAppSelector(
    transactionStatusResponseLoading,
  );
  const invoiceLoading = useAppSelector(invoiceGeneratedLoading);
  const lmrChecked = useAppSelector(lmrCheckedData);
  const [lmrRedeemed, setLmrRedeemed] = useState(false);
  // const statussss = getLmrChecked();
  // const lmrChecked =
  //   statussss === null ? useAppSelector(lmrCheckedData) : statussss;
  const apiHasError = useAppSelector(mmrpError);
  const search = useLocation().search;
  const metaData = getMetadata();
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  const paytmURL = metaData.find(
    (obj: {name: string}) => obj.name === PAYTM_MID_META_KEY,
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }

  const [lmrClicked, setLmrClicked] = useState('0');
  const [priceDetails, setPriceDetails] = useState<PriceDetails | null>(null);
  const [disablePaymentLink, setDisablePaymentLink] = useState(false);
  const [disableQrLink, setDisableQrLink] = useState(false);
  const [disableCheckbox, setDisableCheckbox] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [Qrdata, setQrdata] = useState('');
  const [orderButtonEnable, setOrderButtonEnable] = useState(true);
  const customerProfileData = getUser();
  const [lmrRewardPoints, setLmrRewardPoints] = useState(
    customerProfileData.pointsAvailable * 0.6,
  );
  const [paymentEnabled, setPaymentEnabled] = useState<boolean>(false);
  const scrollerRef = createRef();
  const userType = getUserType();
  const card_number = getUser().cardNumber;
  const storeId = getStoreCode();
  if (userType === null) {
    logout();
  }
  useEffect(() => {
    const statussss = getLmrChecked();
    const data = statussss === null ? lmrChecked : statussss;
    dispatch(setLmrChecked(data));

    const tier = getUser().tier;
    // lmrChecked = false;
    const pointsAvailable = getUser().pointsAvailable;

    if ((tier === 'ELITE' || tier === 'EDGE') && pointsAvailable === 0) {
      setShowLmrpoint(true);
    }
    loadCheckoutScript(paytmURL, setPaymentEnabled);

    if (window && window.Paytm && window.Paytm.CheckoutJS) {
      setPaymentEnabled(true);
    }

    setPageName(pageName.paymentPage);

    const parameters = {
      accessToken: accessToken,
      payload: {
        storeCode: storeCode,
        cardNumber: card_number,
        storeKeyId: storeId,
      },
    };
    dispatch(fetchOrder(parameters));
    dispatch(resetTxnToken());
  }, []);

  useEffect(() => {
    if (apiHasError !== '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description={'Something went wrong! Please try again'}
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetMMRPState());
    }
  }, [apiHasError]);

  useEffect(() => {
    dispatch(setAppBarTitle('Payment'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.GO_BACK));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
      dispatch(resetTxnToken());
      dispatch(resetPaymentStatus());
      dispatch(setLmrChecked(false));
      showPaymentStatus = 0;
    };
  }, []);

  const accessToken = getAccessToken();

  // useEffect(() => {
  //   if (verifyPaymentResp !== null && paymentStatusLoaded === false) {
  //     if (
  //       verifyPaymentResp !== null &&
  //       verifyPaymentResp.resultStatus === 'TXN_SUCCESS'
  //     ) {
  //       paymentAttempCounter = 0;
  //       const orderId = new URLSearchParams(search).get('orderId');
  //       //Call generate invoice api here
  //       const lmrStatus = getLmrChecked();

  //       paymentRecieveMoengageCall(orderResp);
  //       const parameters = {
  //         accessToken,
  //         payload: {
  //           storeCode,
  //           orderId: orderId,
  //           redeemLMR: lmrStatus === null ? false : lmrStatus,
  //           //   redeemLMR: true,
  //         },
  //       };
  //       localStorage.removeItem('lmrchecked');
  //       dispatch(generateInvoice(parameters));
  //     } else if (
  //       verifyPaymentResp !== null &&
  //       verifyPaymentResp.resultStatus === 'TXN_FAILURE'
  //     ) {
  //       paymentAttempCounter = 0;

  //       dispatch(resetInvoiceResponse());
  //       dispatch(resetTransactionResponse());
  //       navigate.push('/checkout/payment_error');
  //     } else if (
  //       verifyPaymentResp !== null &&
  //       verifyPaymentResp.resultStatus != 'TXN_FAILURE' &&
  //       verifyPaymentResp.resultStatus != 'TXN_SUCCESS'
  //     ) {
  //       dispatch(setLoaderRunning(true));
  //       dispatch(resetInvoiceResponse());
  //       dispatch(resetTransactionResponse());
  //       if (paymentAttempCounter === 0) {
  //         cogoToast.success(
  //           <InformationToast
  //             title="Payment procesing"
  //             description={'Please wait...'}
  //           />,
  //           {
  //             hideAfter: 64,
  //             renderIcon: () => {
  //               return null;
  //             },
  //           },
  //         );
  //       } else if (paymentAttempCounter === 1) {
  //         cogoToast.success(
  //           <InformationToast
  //             title="Payment procesing"
  //             description={'Please wait, Transaction is processing'}
  //           />,
  //           {
  //             hideAfter: 64,
  //             renderIcon: () => {
  //               return null;
  //             },
  //           },
  //         );
  //       } else if (paymentAttempCounter === 2) {
  //         cogoToast.success(
  //           <InformationToast
  //             title="Payment procesing"
  //             description={'Please wait, Transaction is still processing'}
  //           />,
  //           {
  //             hideAfter: 64,
  //             renderIcon: () => {
  //               return null;
  //             },
  //           },
  //         );
  //       } else if (paymentAttempCounter === 3) {
  //         orderId = '';
  //         checksum = '';
  //         paymentAttempCounter = 0;
  //         dispatch(setLoaderRunning(false));
  //         clearInterval(paymentAttemptTimer);
  //         navigate.push('/checkout/payment_error');
  //         return;
  //       }

  //       paymentAttemptTimer = window.setInterval(() => {
  //         if (checksum) {
  //           clearInterval(paymentAttemptTimer);
  //           dispatch(setLoaderRunning(false));
  //           let counter = paymentAttempCounter;
  //           const parameters = {
  //             accessToken,
  //             payload: {
  //               checksum,
  //               storeCode,
  //               orderId,
  //               verifyPaymentRetryCount: ++counter,
  //             },
  //             // access_token: 'test',
  //           };
  //           dispatch(verifyPaymentStatus(parameters));
  //         }
  //         paymentAttempCounter++;
  //       }, 65000);
  //     }
  //   }
  //   if (errorInPaymentStatus != '' && paymentStatusLoaded === false) {
  //     //      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');

  //     dispatch(setLoaderRunning(true));

  //     if (paymentAttempCounter === 0) {
  //       cogoToast.success(
  //         <InformationToast
  //           title="Payment procesing"
  //           description={'Please wait...'}
  //         />,
  //         {
  //           hideAfter: 64,
  //           renderIcon: () => {
  //             return null;
  //           },
  //         },
  //       );
  //     } else if (paymentAttempCounter === 1) {
  //       cogoToast.success(
  //         <InformationToast
  //           title="Payment procesing"
  //           description={'Please wait, Transaction is processing'}
  //         />,
  //         {
  //           hideAfter: 64,
  //           renderIcon: () => {
  //             return null;
  //           },
  //         },
  //       );
  //     } else if (paymentAttempCounter === 2) {
  //       cogoToast.success(
  //         <InformationToast
  //           title="Payment procesing"
  //           description={'Please wait, Transaction is still processing'}
  //         />,
  //         {
  //           hideAfter: 64,
  //           renderIcon: () => {
  //             return null;
  //           },
  //         },
  //       );
  //     } else if (paymentAttempCounter === 3) {
  //       dispatch(setPaymentEnableButton(true));
  //       if (checksum != null) {
  //         setCheckSum(checksum);
  //       }

  //       //setLmrCheck(lmrChecked);
  //       orderId = '';
  //       checksum = '';
  //       paymentAttempCounter = 0;
  //       dispatch(setLoaderRunning(false));
  //       clearInterval(paymentAttemptTimer);
  //       navigate.push('/checkout/payment_error');
  //       return;
  //     }
  //     paymentAttemptTimer = window.setInterval(() => {
  //       if (checksum) {
  //         clearInterval(paymentAttemptTimer);
  //         dispatch(setLoaderRunning(false));
  //         let counter = paymentAttempCounter;
  //         if (paymentAttemptStatus) {
  //           counter = 1;
  //           paymentAttemptStatus = false;
  //         }
  //         const parameters = {
  //           accessToken,
  //           payload: {
  //             checksum,
  //             storeCode,
  //             orderId,
  //             verifyPaymentRetryCount: ++counter,
  //           },
  //           // access_token: 'test',
  //         };
  //         dispatch(verifyPaymentStatus(parameters));
  //       }
  //       paymentAttempCounter++;
  //     }, 65000);
  //   }
  // }, [verifyPaymentResp, errorInPaymentStatus, paymentStatusLoaded]);

  useEffect(() => {
    let orderId = new URLSearchParams(search).get('orderId');
    if (!orderId && orderResp !== null) {
      orderId = orderResp.orderId;
    }
    if (invoiceResponse !== null) {
      if (invoiceResponse.txnStatus === 'completed') {
        if (priceDetails?.totalAmount != null) {
          finalOrderPayment(priceDetails.totalAmount.toString());
        }
        purchaseEventGA(
          invoiceResponse.txnNumber,
          orderResp,
          getPriceDetails(orderResp),
        );
        navigate.push('/checkout/confirm');
      } else {
        if (invoiceResponse.statusCode === '1053') {
          navigate.push('/checkout/confirm');
        }

        if (
          invoiceResponse.statusCode === '1054' ||
          invoiceResponse.statusCode === '1055' ||
          invoiceResponse.statusCode === '1056' ||
          invoiceResponse.statusCode === '1057'
        ) {
          navigate.push('/checkout/payment_error');
        } else {
          const parameters = {
            accessToken,
            payload: {
              storeCode: storeCode,
              orderId: orderId,
            },
          };
          dispatch(checkTransactionStatus(parameters));
          // call status check api here
        }
      }
      //  dispatch(resetInvoiceResponse());
      // dispatch(resetTransactionResponse());
    }
    if (invoiGenerationError !== null) {
      if (invoiGenerationError.message != '' && invoiceLoading === false) {
        if (invoiGenerationError.error === 'lmrPointsRedumption') {
          navigate.push('/checkout/payment_error');
        } else {
          navigate.push('/checkout/confirm');
        }

        //dispatch(resetInvoiceResponse());
        //dispatch(resetTransactionResponse());
      }
    }
  }, [invoiceResponse, invoiGenerationError, invoiceLoading]);

  useEffect(() => {
    if (transactionStatusResp) {
      if (transactionStatusResp.statusCode === '200') {
        //redirect to confirm page
        if (priceDetails?.totalAmount != null) {
          finalOrderPayment(priceDetails.totalAmount.toString());
        }
        navigate.push('/checkout/confirm');
      } else {
        navigate.push('/checkout/confirm');
      }

      //  dispatch(resetInvoiceResponse());
      //  dispatch(resetTransactionResponse());
    }
    if (
      transactionStatusLoading === false &&
      transactionStatusRespError != ''
    ) {
      navigate.push('/checkout/confirm');

      //     dispatch(resetInvoiceResponse());
      //dispatch(resetTransactionResponse());
    }
  }, [
    transactionStatusResp,
    transactionStatusLoading,
    transactionStatusRespError,
  ]);

  //redirected to process_payment page
  // useEffect(() => {
  //   checksum = new URLSearchParams(search).get('checksum');
  //   orderId = new URLSearchParams(search).get('orderId');
  //   if (checksum) {
  //     setPayNowButtonEnable(true);
  //     const parameters = {
  //       accessToken,
  //       payload: {
  //         checksum,
  //         storeCode,
  //         orderId,
  //         verifyPaymentRetryCount: 0,
  //       },
  //       // access_token: 'test',
  //     };
  //     dispatch(verifyPaymentStatus(parameters));
  //   }
  // }, []);

  useEffect(() => {
    if (lmrChecked) {
      console.log('payment data ', priceDetails?.totalAmount);
      if (priceDetails?.totalAmount === 0) {
        setOrderButtonEnable(false);
        setDisableQrLink(true);
        setDisablePaymentLink(true);
      }
    } else {
      setOrderButtonEnable(true);
      setDisableQrLink(false);
      setDisablePaymentLink(false);
    }
  }, [lmrChecked]);
  console.log('payment', priceDetails?.totalAmount);

  function getPriceDetails(resp: any, bool?: boolean) {
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    let couponDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item && item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
    }
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponDiscount += item.couponDiscountAmount;
        } else couponDiscount = 0;
      });
    let lmrRewardsPrice = 0;
    if (bool) {
      lmrRewardsPrice = lmrRewardPoints;
    } else {
      lmrRewardsPrice = 0;
    }
    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    totalAmount = totalAmount + bagPrice - lmrRewardsPrice;

    return {
      totalMRP,
      promoDiscountAmount,
      totalAmount,
      lmrRewardsPrice,
    };
  }
  useEffect(() => {
    if (
      lmrClicked === '0' &&
      priceDetails != null &&
      priceDetails?.totalAmount != undefined &&
      lmrChecked
    ) {
      console.log(
        'rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr',
        priceDetails,
      );
      changeTotalAmount(true);
      setLmrClicked('2');
    }
  }, [priceDetails, lmrChecked, lmrClicked]);

  useEffect(() => {
    if (orderResp !== null) {
      const priceDetail = getPriceDetails(orderResp);
      setPriceDetails({
        totalMRP: priceDetail.totalMRP,
        promoDiscountAmount: priceDetail.promoDiscountAmount,
        totalAmount: priceDetail.totalAmount,
      });
      if (userType === 'employee') {
        if (
          orderResp.paymentStatus !== undefined &&
          orderResp.paymentStatus === true
        ) {
          if (showPaymentStatus === 0) {
            setOrderButtonEnable(false);
            setDisableQrLink(true);
            setDisablePaymentLink(true);
            setDisableCheckbox(true);
            cogoToast.success(
              <InformationToast
                title="Payment Status Pending"
                description={
                  'Look like payment status of last order is still pending.Please click payment status button to check the status '
                }
              />,
              {
                hideAfter: 10,
                renderIcon: () => {
                  return null;
                },
              },
            );
            showPaymentStatus++;
          }
        }
      }
      //console.log(orderResp?.linkId);
    } else {
      console.log('----> orderresp not there');
    }
  }, [orderResp]);

  useEffect(() => {
    if (txn_Token && 'invalid-order' === txn_Token.status) {
      navigate.push('/checkout/invalid-order');
    }

    if (txn_Token && txn_Token.status === 'S') {
      //directed to redeem lmr api response
      // if (priceDetails?.totalAmount === 0) {
      //   const orderId = orderResp && orderResp.orderId;
      //   //Call generate invoice api here
      //   const parameters = {
      //     accessToken,
      //     payload: {
      //       storeCode,
      //       orderId: orderId,
      //       redeemLMR: lmrChecked ? true : false,
      //     },
      //   };
      //   dispatch(generateInvoice(parameters));
      // } else {
      const config = {
        root: '',
        flow: 'DEFAULT',
        merchant: {
          logo: 'https://buddy.maxfashion.in/assets/common/max_logo.png',
          name: ' ',
        },
        style: {
          headerBackgroundColor: '#8dd8ff',
          headerColor: '#3f3f40',
          bodyColor: '#303AB2',
        },
        data: {
          orderId: txn_Token.paymentOrderId,
          token: txn_Token.txnToken,
          tokenType: 'TXN_TOKEN',
          amount: lmrChecked
            ? lmrRedeemed
              ? priceDetails?.totalAmount
              : priceDetails?.lmrRewardsPrice
              ? priceDetails?.totalAmount - priceDetails?.lmrRewardsPrice
              : 0
            : priceDetails?.totalAmount,
        },
        handler: {
          notifyMerchant: function (eventName: string, data: any) {
            if (eventName == 'SESSION_EXPIRED') {
              alert('Your session has expired!!');
              location.reload();
            }
          },
        },
      };
      if (window.Paytm && window.Paytm.CheckoutJS) {
        dispatch(setActivityRunning(true));
        // initialze configuration using init method
        window.Paytm.CheckoutJS.init(config)
          .then(function onSuccess() {
            dispatch(setActivityRunning(false));
            // after successfully update configuration invoke checkoutjs
            window.Paytm.CheckoutJS.invoke();
          })
          .catch(function onError(error: any) {
            dispatch(setActivityRunning(false));
            cogoToast.error(
              <ErrorToast
                title="Error"
                description={
                  error.message || 'Something went wrong! please try again'
                }
              />,
              {
                hideAfter: 3,
                renderIcon: () => {
                  return null;
                },
              },
            );
            console.log('Error => ', error);
          });
      }
      //}
      //dispatch(resetOrderState());
      //navigate.push('/home');
    }
    if (txn_Token && txn_Token.status === 'F') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong! please try again"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [txn_Token]);

  useEffect(() => {
    const checksum = new URLSearchParams(search).get('checksum');
    // if (orderResp && orderResp.orderId && !checksum) {
    //   const requestOptions = {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${getAccessToken()}`,
    //     },
    //     body: JSON.stringify({
    //       orderId: orderResp.orderId,
    //       storeCode: storeCode,
    //     }),
    //   };
    //   fetch('http://localhost:3001/order/request-payment-token', requestOptions)
    //     .then(res => res.json())
    //     .then(data => {
    //       console.log('data', data);
    //       setTxnToken(data.body.txnToken);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
    if (orderResp && orderResp.itemList && orderResp.itemList.length === 0) {
      navigate.push('/checkout');
    }
  }, [orderResp]);

  // const userLong = location.coordinates.lat;
  // const userLat = location.coordinates.lng;

  // function distancePoints(
  //   userLat: any,
  //   userLong: any,
  //   storeLat: any,
  //   storeLong: any,
  // ) {
  //   // distance between latitudes
  //   // and longitudes
  //   const dLat = ((storeLat - userLat) * Math.PI) / 180.0;
  //   const dLon = ((storeLong - userLong) * Math.PI) / 180.0;

  //   // convert to radiansa
  //   userLat = (userLat * Math.PI) / 180.0;
  //   storeLat = (storeLat * Math.PI) / 180.0;

  //   // apply formulae
  //   const a =
  //     Math.pow(Math.sin(dLat / 2), 2) +
  //     Math.pow(Math.sin(dLon / 2), 2) * Math.cos(userLat) * Math.cos(storeLat);
  //   const rad = 6371;
  //   const c = 2 * Math.asin(Math.sqrt(a));
  //   return rad * c;
  // }

  useEffect(() => {
    if (lmrRedeemResponse !== null) {
      if (lmrRedeemResponse.statusCode === '200') {
        setLmrRedeemed(true);
        if (priceDetails?.totalAmount === 0) {
          const orderId = orderResp && orderResp.orderId;
          //Call generate invoice api here
          const parameters = {
            accessToken,
            payload: {
              storeCode,
              orderId: orderId,
              redeemLMR: false,
            },
          };
          dispatch(generateInvoice(parameters));
        } else {
          if (orderResp && orderResp.orderId) {
            const parameters = {
              accessToken: getAccessToken(),
              payload: {
                orderId: orderResp.orderId,
                storeCode,
                redeemLMR: true,
              },
            };
            dispatch(requestTxnToken(parameters));
          }
        }
      } else if (lmrRedeemResponse.statusCode === '1056') {
        setLmrRedeemed(false);
        cogoToast.success(
          <InformationToast
            title="LMR not redeemed"
            description={String(lmrRedeemResponse.statusMessage)}
          />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );
        if (orderResp && orderResp.orderId) {
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              orderId: orderResp.orderId,
              storeCode,
              redeemLMR: false,
            },
          };
          dispatch(requestTxnToken(parameters));
        }
        setLmrCheck(false);
      } else if (lmrRedeemResponse.statusCode === '1055') {
        setLmrRedeemed(false);
        cogoToast.success(
          <InformationToast
            title="LMR not redeemed"
            description={String(lmrRedeemResponse.statusMessage)}
          />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );
        if (orderResp && orderResp.orderId) {
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              orderId: orderResp.orderId,
              storeCode,
              redeemLMR: false,
            },
          };
          dispatch(requestTxnToken(parameters));
        }
        setLmrCheck(false);
      } else if (lmrRedeemResponse.statusCode === '1054') {
        setLmrRedeemed(false);
        cogoToast.success(
          <InformationToast
            title="LMR not redeemed"
            description={String(lmrRedeemResponse.statusMessage)}
          />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );
        if (orderResp && orderResp.orderId) {
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              orderId: orderResp.orderId,
              storeCode,
              redeemLMR: false,
            },
          };
          dispatch(requestTxnToken(parameters));
        }
        setLmrCheck(false);
      }
    }
    if (lmrRedeemError !== '' && lmrRedeemLoading === false) {
      console.log('incase of api not working');
    }
    dispatch(resetLmrRedeemDataResponse());
  }, [lmrRedeemResponse, lmrRedeemError, lmrRedeemLoading]);

  function handlePayNowClick() {
    beginPayment(orderResp);
    setOrderResp(orderResp);
    //if payment zero then call generate invoice api
    const paymentMode = 'js checkout';
    dispatch(setPaymentMode(paymentMode));

    if (orderResp && orderResp.hasPaid === true) {
      const orderId = orderResp && orderResp.orderId;
      //Call generate invoice api here
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderId,
          redeemLMR: false,
        },
      };
      dispatch(generateInvoice(parameters));
    } else {
      if (!paymentEnabled) {
        console.error('Payment script is not loaded...');
        return;
      }

      if (lmrChecked) {
        if (orderResp && orderResp.orderId) {
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              orderId: orderResp.orderId,
              storeCode,
            },
          };
          dispatch(lmrRedeemData(parameters));
          onPayNowMoengageEvent(orderResp);
        } else {
          console.warn('Order id is missing...');
        }
      } else {
        if (orderResp && orderResp.orderId) {
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              orderId: orderResp.orderId,
              storeCode,
              redeemLMR: lmrChecked ? true : false,
            },
          };
          dispatch(requestTxnToken(parameters));

          onPayNowMoengageEvent(orderResp);
        }
      }
    }
  }

  useEffect(() => {
    if (qrCodeResp.body.resultInfo.resultStatus != '') {
      if (qrCodeResp.body.resultInfo.resultCode == 'QR_0001') {
        setDisableQrLink(true);
        if (orderResp) {
          generatedOrderId = orderResp.orderId;
        }

        //setDisablePaymentLink(true);
        setShowQrCode(true);
        setQrdata(qrCodeResp.body.qrData);

        settimer2 = window.setTimeout(() => {
          //  checkcallBack();
          setOrderButtonEnable(false);
        }, 60000);
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description="Something went wrong Please try after some time!!"
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
      dispatch(resetQrPaymentState());
    }
    if (qrPayementError != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong Please try after some time!!"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetQrPaymentState());
    }
  }, [qrCodeResp, qrPayementError, qrPaymentHasLLoaded]);
  const scanQrCodeHandler = () => {
    genertedLinkId = '';
    generatedOrderId = '';
    if (settimer1 != 0) {
      console.log(settimer1);
      clearTimeout(settimer1);
      settimer1 = 0;
      if (timer2 != 0) {
        clearInterval(timer2);
      }
      setDisablePaymentLink(false);
    }
    setOrderButtonEnable(true);
    if (orderResp && orderResp.orderId) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
          redeemLMR: lmrChecked ? true : false,
        },
      };
      dispatch(qrCodePayment(parameters));
    }
    // //genertedLinkId = '';
    // generatedOrderId = '';
    // if (settimer1 != 0) {
    //   console.log(settimer1);
    //   clearTimeout(settimer1);
    //   settimer1 = 0;
    //   if (timer != 0) {
    //     clearInterval(timer);
    //   }
    //   //   setDisablePaymentLink(false);
    // }
    // const ordersId = 'TEST_' + new Date().getTime();
    // generatedOrderId = ordersId;
    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     orderId: ordersId,
    //     amount: 1,
    //     //amount: priceDetails?.totalAmount,
    //     customerId: 'CUST_123',
    //   }),
    // };
    // //TODO:
    // //add logic if api not working like 501 internal server error
    // fetch('https://93e65177245a.ngrok.io/create-qr-code', requestOptions)
    //   .then(res => res.json())
    //   .then(data => {
    //     if (data.body.resultInfo.resultCode == 'QR_0001') {
    //       setDisableQrLink(true);
    //       //  setDisablePaymentLink(true);
    //       setShowQrCode(true);
    //       setQrdata(data.body.qrData);

    //       settimer2 = window.setTimeout(() => {
    //         checkcallBack();
    //         setOrderButtonEnable(false);
    //       }, 20000);
    //     } else {
    //       cogoToast.error(
    //         <ErrorToast
    //           title="Error"
    //           description="Something went wrong Please try after some time!!"
    //         />,
    //         {
    //           hideAfter: 3,
    //           renderIcon: () => {
    //             return null;
    //           },
    //         },
    //       );
    //     }
    //     console.log('data', data);
    //     dispatch(setTxnToken(data.body.txnToken));
    //   });
  };
  useEffect(() => {
    if (requestLinkResp.body.resultInfo.resultCode != '') {
      if (requestLinkResp.body.resultInfo.resultCode == '200') {
        genertedLinkId = requestLinkResp.body.linkId;
        setDisablePaymentLink(true);
        //setDisableQrLink(true);
        console.log(genertedLinkId);
        settimer1 = window.setTimeout(() => {
          //           checkcallBack();
          setOrderButtonEnable(false);
        }, 60000);
        console.log(genertedLinkId);
        cogoToast.success(
          <SuccessToast
            title="Success!"
            description="Message Sent Successfully"
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description="Something went wrong Please try after some time!!"
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
      dispatch(resetLinkPaymentState());
    }
    if (requestLinkError != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong Please try after some time!!"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetLinkPaymentState());
    }
  }, [requestLinkResp, requestLinkError, requestLinkPaymenthasLoaded]);
  const paymentLinkHandler = () => {
    genertedLinkId = '';
    generatedOrderId = '';
    if (settimer2 != 0) {
      clearTimeout(settimer2);
      settimer2 = 0;
      if (timer2 != 0) {
        clearInterval(timer2);
      }
      setDisableQrLink(false);
    }
    setOrderButtonEnable(true);
    if (orderResp && orderResp.orderId) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
          redeemLMR: lmrChecked ? true : false,
        },
      };
      dispatch(requestLinkPayment(parameters));
    }
  };

  useEffect(() => {
    if (paymentVerifyResp.resultCode != '') {
      if (
        paymentVerifyResp.resultCode == '200' ||
        paymentVerifyResp.resultCode == '01'
      ) {
        paymentEmpCount = 0;
        if (paymentVerifyResp.resultCode == '200') {
          dispatch(setPaymentMode('send payment link method'));
        }
        if (paymentVerifyResp.resultCode == '01') {
          dispatch(setPaymentMode('scan qr payment method'));
        }
        clearInterval(timer2);
        generatedOrderId = '';
        generatedOrderId = '';
        if (orderResp) {
          const orderId = orderResp && orderResp.orderId;
          //Call generate invoice api here
          const parameters = {
            accessToken,
            payload: {
              storeCode,
              orderId: orderId,
              redeemLMR: lmrChecked ? true : false,
            },
          };
          dispatch(generateInvoice(parameters));
          // navigate.push('/checkout/confirm');
        }
      } else {
        if (paymentEmpCount == 3) {
          employeePaymentCheckCounter = 0;
          dispatch(setLoaderRunning(false));
          paymentEmpCount = 0;
          clearInterval(timer2);
          navigate.push('/checkout/payment_error');
          return;
        }
        dispatch(setLoaderRunning(true));
        if (employeePaymentCheckCounter === 0) {
          cogoToast.success(
            <InformationToast
              title="Payment procesing"
              description={'Please wait...'}
            />,
            {
              hideAfter: 14,
              renderIcon: () => {
                return null;
              },
            },
          );
        }
        if (employeePaymentCheckCounter === 1) {
          cogoToast.success(
            <InformationToast
              title="Payment procesing"
              description={'Please wait, Transaction is still processing'}
            />,
            {
              hideAfter: 14,
              renderIcon: () => {
                return null;
              },
            },
          );
        }
        if (employeePaymentCheckCounter === 2) {
          dispatch(setLoaderRunning(false));
        }
        employeePaymentCheckCounter++;

        dispatch(resetVerifyPaymentState());
      }
      dispatch(resetVerifyPaymentState());
    }
    if (verifyPaymentError != '') {
      if (paymentEmpCount == 3) {
        employeePaymentCheckCounter = 0;

        paymentEmpCount = 0;

        dispatch(setLoaderRunning(false));
        clearInterval(timer2);
        navigate.push('/checkout/payment_error');
      }
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong ... please try after some time!!"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [paymentVerifyResp, verifyPaymentError, verifyPaymentHasLoaded]);
  const checkPaymentStatus = (linkIdData: string) => {
    if (linkIdData === '') {
      if (orderResp && orderResp.orderId) {
        const parameters = {
          accessToken,
          payload: {
            storeCode,
            orderId: orderResp.orderId,
            verifyPaymentRetryCount: ++paymentEmpCount,
          },
        };

        dispatch(paymenrVerification(parameters));
      }
    } else {
      if (orderResp && orderResp.orderId) {
        const parameters = {
          accessToken,
          payload: {
            storeCode,
            orderId: orderResp.orderId,
            linkId: linkIdData.toString(),
            verifyPaymentRetryCount: ++paymentEmpCount,
          },
        };

        dispatch(paymenrVerification(parameters));
      }
    }
  };

  const handleOrderStatus = () => {
    if (priceDetails?.totalAmount === 0) {
      if (orderResp) {
        const orderId = orderResp && orderResp.orderId;
        //Call generate invoice api here
        const parameters = {
          accessToken,
          payload: {
            storeCode,
            orderId: orderId,
            redeemLMR: lmrChecked ? true : false,
          },
        };
        dispatch(generateInvoice(parameters));
        // navigate.push('/checkout/confirm');
      }
      return;
    }
    let count = 0;
    let tempData = '';
    //  let count1 = 0;
    setOrderButtonEnable(true);
    if (generatedOrderId === '' && genertedLinkId === '') {
      if (orderResp != null) {
        if (orderResp.paymentMode === qrPaymentMode) {
          tempData = '';
          checkPaymentStatus(tempData);
        }
        if (orderResp.paymentMode === linkPaymentMode) {
          if (orderResp.linkId != undefined) {
            tempData = orderResp.linkId;
            checkPaymentStatus(tempData);
          }
        }
      }
    } else {
      if (generatedOrderId != '') {
        tempData = '';
        checkPaymentStatus(tempData);
      }
      if (genertedLinkId != '') {
        tempData = genertedLinkId;
        checkPaymentStatus(tempData);
      }
    }
    timer2 = window.setInterval(() => {
      checkPaymentStatus(tempData);

      if (++count === 2) {
        cogoToast.error(
          <ErrorToast title="Error" description="Payment not done!!" />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );

        clearInterval(timer2);
        setDisableQrLink(false);
        setDisablePaymentLink(false);

        dispatch(resetVerifyPaymentState());

        return;
      }
    }, 15000);
  };
  const _onViewDetailsClicked = () => {
    if (scrollerRef.current) {
      const _el = scrollerRef.current as HTMLDivElement;
      _el.scrollTo({top: _el.scrollHeight});
    }
  };

  function changeTotalAmount(bool: boolean) {
    console.log('ssssssssssssssssssssssssssssssssssssssssss');
    if (priceDetails) {
      const {totalAmount} = priceDetails;
      console.log(priceDetails);
      if (bool) {
        if (lmrRewardPoints > totalAmount) {
          const remainingLMRPoints = lmrRewardPoints - totalAmount;
          const availedLMRPoints = lmrRewardPoints - remainingLMRPoints;
          setLmrRewardPoints(remainingLMRPoints);
          setPriceDetails({
            ...priceDetails,
            lmrRewardsPrice: availedLMRPoints,
            totalAmount:
              Number(availedLMRPoints.toFixed(2)) -
              Number(totalAmount.toFixed(2)),
          });
        } else {
          setLmrRewardPoints(0);
          setPriceDetails({
            ...priceDetails,
            lmrRewardsPrice: lmrRewardPoints,
            totalAmount:
              Number(totalAmount.toFixed(2)) -
              Number(lmrRewardPoints.toFixed(2)),
          });
        }
      } else {
        setLmrRewardPoints(customerProfileData.pointsAvailable * 0.6);
        setPriceDetails(getPriceDetails(orderResp, bool));
      }
    }
  }

  console.log(disableQrLink);
  return (
    <>
      {orderResp && priceDetails !== null && (
        <div>
          {showQrCode ? (
            <ScanQrModel
              isVisible
              className="tour-modal"
              //   crossVisible={false}
              onClose={() => {
                setShowQrCode(false);
              }}>
              <QRCode value={Qrdata} />
            </ScanQrModel>
          ) : (
            ''
          )}
          <div
            className="flex flex-col m-auto pt-4 px-6 h-screen overflow-y-scroll"
            ref={scrollerRef as React.RefObject<HTMLDivElement>}>
            <div className="stepper-container-horizontal mb-11">
              <Stepper />
            </div>
            <div className="font-bold text-semibig leading-5 tracking-wide pb-6 pl-4">
              <span>Payment options</span>
            </div>
            {customerProfileData.pointsAvailable >= 166 && (
              <div className="pl-4 pt-4 pb-4 shadow-max rounded-radius10 mb-6">
                <div className="flex justify-between">
                  <div className="flex">
                    <div className="checkbox-wrapper block">
                      <label className="text-xxs font-roboto checkbox-container flex items-center">
                        <input
                          type="checkbox"
                          className="h-5 w-5"
                          name="whatsappApi"
                          disabled={showLmrPoint || disableCheckbox}
                          checked={lmrChecked}
                          onChange={() => {
                            if (lmrChecked === true) {
                              setLmrClicked('1');
                              dispatch(setLmrChecked(false));
                              setLmrCheck(false);
                              changeTotalAmount(false);
                            } else {
                              setLmrClicked('2');
                              dispatch(setLmrChecked(true));
                              setLmrCheck(true);
                              changeTotalAmount(true);
                            }
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div className="mt-1">
                    <span className="text-small">Landmark Rewards</span>
                  </div>
                  <div className="ml-2 mt-2">
                    <img src={LandMarkReward} className="h-4" />
                  </div>
                  <div className=" text-tiny text-right ml-3 mt-2">
                    Bal{' '}
                    <span className="font-bold">
                      {'\u20B9'} {lmrRewardPoints.toFixed(2)}
                    </span>
                  </div>

                  <div className="-mt-6">
                    <div data-tip data-for="registerTip">
                      <img
                        className="h-6 bg-white rounded-full"
                        src={infoIcon}
                      />
                    </div>
                    <div className="">
                      <ReactTooltip
                        id="registerTip"
                        place="top"
                        effect="solid"
                        event="click"
                        backgroundColor="white"
                        clickable={true}
                        textColor="black"
                        className="-left-20 w-3/5 top-48 lmr-tooltip">
                        Save with Landmark rewards – use your points
                      </ReactTooltip>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div>
              {userType === 'employee' ? (
                <div>
                  <div>
                    <button
                      onClick={scanQrCodeHandler}
                      className={`p-4 w-full shadow-max rounded-radius10 mb-6 text-left focus:outline-none ${
                        disableQrLink ? 'bg-gray-400 cursor-not-allowed' : ''
                      }`}
                      disabled={disableQrLink}>
                      <span className="font-bold font-semibig leading-5 tracking-wide">
                        Scan QR
                      </span>
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={paymentLinkHandler}
                      className={`p-4 w-full shadow-max rounded-radius10 mb-6 text-left focus:outline-none ${
                        disablePaymentLink
                          ? 'bg-gray-400 cursor-not-allowed'
                          : ''
                      }`}
                      disabled={disablePaymentLink}>
                      <span className="font-bold font-semibig leading-5 tracking-wide">
                        Send payment link
                      </span>
                    </button>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>

            {orderResp && (
              <ProductCard
                type="price"
                orderResp={orderResp}
                priceDetails={priceDetails}
              />
            )}
          </div>

          {userType === 'employee' && orderResp && (
            <div>
              <CartInfo
                className="mb-2"
                from="payment"
                disabled={!lmrChecked && priceDetails?.totalAmount === 0}
                showViewDetails={false}
                onViewDetailsClicked={_onViewDetailsClicked}
                orderButtonVisibility={
                  orderButtonEnable ||
                  (!lmrChecked && priceDetails?.totalAmount === 0)
                }
                onOrderStatus={handleOrderStatus}
                totalAmount={priceDetails?.totalAmount}
              />
            </div>
          )}
          {orderResp && userType !== 'employee' && (
            <CartInfo
              className="mb-2"
              showViewDetails={false}
              from="payment"
              disabled={
                (!lmrChecked &&
                  priceDetails?.totalAmount === 0 &&
                  !paymentEnabled) ||
                payNowButton
              }
              onPayNow={handlePayNowClick}
              totalAmount={priceDetails?.totalAmount}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Payment;
